import PropTypes from 'prop-types';
import React, { useEffect, useState, useCallback } from 'react';
import { EditorState } from 'draft-js';

var _ = require('lodash');
import Select, { components } from 'react-select'
import AsyncSelect from 'react-select/async';
import EventTemplateSelect from '../../../shared/EventTemplateSelect';
import AsyncCreatableSelect from 'react-select/async-creatable';
import CreateEntityModal from '../../../shared/CreateEntityModal';
import darkSelectStyles from '../../../shared/darkSelectStyles';
const axios = require('axios').default;
import { ToastContainer, toast } from 'react-toastify';
import Popup from "reactjs-popup";
import CopyOffersPicker from "../../shared/components/CopyOffersPicker";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import RichEditor from '../../RichEditor/components/RichEditor';
import { applyDefaultStart } from '../actions/eventFormActionCreators';
var moment = require('moment');

import { tippy } from '@tippyjs/react';
import Flatpickr from "react-flatpickr";
import { confirmDateTimePickerProps } from '../../../shared/confirmDateTimePicker';
import DayPicker, { DateUtils } from 'react-day-picker';
import { DebounceInput } from 'react-debounce-input';
import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

import HoldPositionPicker from './HoldPositionPicker';
import RoomSelector from '../../../shared/RoomSelector';
import useVenueAgeRestrictionOptions from '../../shared/hooks/useVenueAgeRestrictionOptions';
import ArtistChipsField from '../../shared/components/ArtistChipsField';
import VenueFormModal from '../../SettingsVenueDetails/components/VenueFormModal';
import { buildCreatedVenueSelection } from '../buildCreatedVenueSelection';

import {
  offsetDateForBrowser
} from '../../../shared/timeZoneLogic';

const onDayCreate = (dObj, dStr, fp, dayElem) => {
  let dateStr = dayElem.getAttribute('aria-label');
  let date = new Date(dateStr);
  let tooltipContent = "";
  let showTooltip = false;

  if (typeof fp.eventStart === 'undefined' || typeof fp.eventEnd === 'undefined') {
    return;
  }

  if (date && (fp.isEventStart || fp.isEventEnd)) {
    let normalizedEventStart = new Date(fp.eventStart.getFullYear(), fp.eventStart.getMonth(), fp.eventStart.getDate());
    let normalizedEventEnd = new Date(fp.eventEnd.getFullYear(), fp.eventEnd.getMonth(), fp.eventEnd.getDate());

    if (fp.isEventStart && date > normalizedEventEnd) {
      tooltipContent = "Event Start must be on or before Event End";
      showTooltip = true;
    }

    if (fp.isEventEnd && date < normalizedEventStart) {
      tooltipContent = "Event End must be on or after Event Start";
      showTooltip = true;
    }
  }

  if (showTooltip) {
    tippy(dayElem, {
      content: tooltipContent,
      zIndex: 999999
    });
  }
};

const tooltipContentStyle = {
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "marginTop": "-10px",
  "padding": "6px 9px",
  "textAlign": "center"
}

const modalContentStyle = {
  "textAlign": "left",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "360px",
  "padding": "15px"
}

const selectStyles = darkSelectStyles;


const canSubmitForm = function(calendarEventType, calendarEventTitle, selectedRooms, holdGroup, confirm, submittingForm, makeUnavailable, forDuplication){
  var baseConditions = (
    calendarEventTitle
      && calendarEventTitle.length > 0
      && selectedRooms && selectedRooms.length > 0
      && !submittingForm
  );

  if (calendarEventType === "HoldGroup") {
    var hasHoldGroupEntry = (holdGroup.hold_group_entries || []).find((holdGroupEntry) => {
      return !holdGroupEntry._destroy;
    });

    var allHoldsHaveAPosition = (holdGroup.hold_group_entries || []).every((holdGroupEntry) => {
      return holdGroupEntry.hold.position;
    });

    var hasAtLeastOneAvailableHoldPosition = (
      !makeUnavailable || (holdGroup.hold_group_entries || []).some(holdGroupEntry => {
        var firstHoldAvailability = (holdGroupEntry.hold.hold_availability || [])[0];
        return firstHoldAvailability && !firstHoldAvailability.is_confirm;
      })
    );

    return (
      baseConditions
      && hasHoldGroupEntry
      && allHoldsHaveAPosition
      && hasAtLeastOneAvailableHoldPosition
    );
  } else {
    if (!forDuplication && holdGroup.id) {
      return (
        baseConditions
        && confirm.hold
        && confirm.start_time
        && confirm.door_time
        && confirm.end_time
      );
    } else {
      return (
        baseConditions
        && confirm.start_time
        && confirm.door_time
        && confirm.end_time
      );
    }
  }
}

const canDeleteConfirmOrHoldGroup = function (holdGroup, confirm) {
  var holdGroupIsPersisted = (
    holdGroup
    && holdGroup.id
  );

  var confirmIsPersisted = (
    confirm
    && confirm.id
  );

  return (
    holdGroupIsPersisted
    || confirmIsPersisted
  );
}



const debouncedFetchBuyers = _.debounce((team, inputValue, callback) => {
  new Promise(resolve => {
    axios.get(`/teams/${team.id}/companies/autocomplete`, {
      params: {
        name: inputValue
      }
    })
      .then(function (response) {
        callback(response.data);
      })
  });
}, 250);

const debouncedFetchPromoters = _.debounce((team, inputValue, callback) => {
  new Promise(resolve => {
    axios.get(`/teams/${team.id}/promoters/autocomplete`, {
      params: {
        name: inputValue
      }
    })
      .then(function (response) {
        callback(response.data);
      })
  });
}, 250);

const createBuyer = (team, buyer, successCallback, errorCallback) => {
  axios.post(`/teams/${team.id}/companies`, {
    company: {
      name: buyer
    }
  })
    .then(response => successCallback(response.data))
    .catch(errorCallback)
};

const deleteBuyer = (team, buyerId, successCallback, errorCallback) => {
  axios.delete(`/teams/${team.id}/companies/${buyerId}`)
    .then(successCallback)
    .catch(errorCallback)
};

const BuyerOption = ({ onDelete, ...props }) => (
  <components.Option {...props}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span>{props.data.label}</span>
      <button
        type="button"
        aria-label={`Delete ${props.data.label}`}
        onClick={(e) => {
          e.stopPropagation();
          onDelete(props.data);
        }}
        style={{ color: 'var(--sl-text-quaternary)', background: 'none', border: 'none' }}
        onMouseEnter={(e) => e.currentTarget.style.color = 'var(--sl-text-error)'}
        onMouseLeave={(e) => e.currentTarget.style.color = 'var(--sl-text-quaternary)'}
      >
        <i className="fas fa-trash"></i>
      </button>
    </div>
  </components.Option>
);

const createPromoter =(team, promoter, successCallback, errorCallback) => {
  axios.post(`/teams/${team.id}/promoters`, {
    promoter: {
      name: promoter
    }
  })
    .then(response => successCallback(response.data))
    .catch(errorCallback)
};

const fetchCanonicalTags = async (team) => {
  try {
    const response = await axios.get(`/teams/${team.id}/canonical_tags`);
    return response.data.canonical_tags || [];
  } catch (error) {
    console.error('Error fetching canonical tags:', error.response || error);
    return [];
  }
};

const flatPickrFormat = "n/j/y at h:iK"

const EventForm = ({
  formTitle,
  formButtonLabel,
  csrfToken,
  team,
  venuesOptions,
  venueSelected,
  rooms,
  venueOwnerships,
  submitEventForm,
  updateSelectedVenue,
  calendarEventFormClosed,
  deleteEvent,
  holdGroup = {},
  confirm = {},
  confirmChanged,
  calendarEventTitle,
  updateCalendarEventTitle,
  calendarEventArtists,
  updateCalendarEventArtists,
  calendarEventType,
  updateCalendarEventType,
  calendarEventTicketForecast,
  calendarEventTicketForecastChanged,
  calendarEventNoteEditorState,
  updateCalendarEventNoteEditorState,
  calendarEventErrors,
  userChangedCalendarEventTitle,
  holdGroupCalendarDateClicked,
  holdGroupDates,
  holdGroupHoldPositionUpdated,
  holdPositionTargetToggled,
  holdGroupHoldRemoved,
  confirmStartDateUpdated,
  confirmStartTimeUpdated,
  fetchHoldAvailability,
  confirmHoldUpdated,
  calendarRef,
  calendarStartDate,
  onClose,
  onSuccess,
  selectedPromoter,
  selectedPromoterChanged,
  buyers,
  buyersChanged,
  promoters,
  promotersChanged,
  selectedBuyer,
  selectedBuyerChanged,
  currentUser,
  holdGroupDeletion,
  holdGroupDeletionChanged,
  holdGroupDeletionReasonChanged,
  holdGroupDeletionExplanationChanged,
  holdGroupDeletionFollowUpChanged,
  holdGroupDeletionFollowUpAtChanged,
  deleteHoldGroup,
  onVenueChange,
  submittingForm,
  doorsTimeDefault,
  eventEndTimeDefault,
  eventTimeDefaults,
  userChangedDoorsTime,
  userChangedDoorsTimeChanged,
  userChangedEventEndTime,
  userChangedEventEndTimeChanged,
  applyTimeDefaults,
  holdGroupChanged,
  forDuplication,
  draggableHeader,
  preSelectedRooms = [],
  canManageVenues = false,
  roomsChanged,
  venueOwnershipsChanged,
  venueStateOptions = [],
  availableTimezones = []
}) => {
  const [makeUnavailable, setMakeUnavailable] = useState(false);
  const [startTimeValue, setStartTimeValue] = useState(null);
  const [pickerFloor] = useState(() => new Date());
  const refreshPickerFloor = (_dates, _dateText, instance) => {
    instance.set('minDate', new Date());
    if (instance.selectedDates.length === 0) instance.clear(false, false);
  };

  const dateTimePickerProps = ({ value, minDate, minDateMessage, unavailableMessage, options, defaultTime, onDates }) => confirmDateTimePickerProps({
    typedEntry: team.calendar_typed_date_entry_enabled,
    dateFormat: flatPickrFormat,
    minDate,
    minDateMessage,
    unavailableMessage,
    options,
    value,
    defaultTime,
    onDates,
    onInvalidEntry: (message) => toast.error(message)
  });
  const defaultStartMinute = eventTimeDefaults && eventTimeDefaults.default_start_minute != null ? Number(eventTimeDefaults.default_start_minute) : null;
  const emptyStartClock = (!confirm.start_time && defaultStartMinute != null)
    ? { defaultHour: Math.floor(defaultStartMinute / 60), defaultMinute: defaultStartMinute % 60 }
    : {};
  const [localNoteEditorState, setLocalNoteEditorState] = useState(calendarEventNoteEditorState || EditorState.createEmpty());
  const [canonicalTags, setCanonicalTags] = useState([]);
  const [selectedGenreTags, setSelectedGenreTags] = useState([]);
  const [selectedEventTypeTags, setSelectedEventTypeTags] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [contactsExpanded, setContactsExpanded] = useState(false);
  const [newContactForm, setNewContactForm] = useState(null);
  const [ageRestrictionExpanded, setAgeRestrictionExpanded] = useState(false);
  const [showNewBuyerModal, setShowNewBuyerModal] = useState(false);
  const [newBuyerName, setNewBuyerName] = useState('');
  const [buyerToDelete, setBuyerToDelete] = useState(null);
  const [showNewPromoterModal, setShowNewPromoterModal] = useState(false);
  const [newPromoterName, setNewPromoterName] = useState('');
  const [showVenueModal, setShowVenueModal] = useState(false);

  const defaultRoomIds = (
    preSelectedRooms.length > 0 ? preSelectedRooms.map((r) => r.id) : (confirm.room_ids || [])
  );

  const [selectedRooms, setSelectedRooms] = useState(
    rooms.filter((r) =>
      defaultRoomIds.includes(r.id)
    ).map((r) => {
      return {
        value: r.id,
        label: r.name,
        room: r,
        venueOwnershipId: r.venue_ownership_id
      };
    })
  );

  const [userManuallyChangedEventType, setUserManuallyChangedEventType] = useState(false);
  const [detectionResult, setDetectionResult] = useState(null);
  const [detectionLoading, setDetectionLoading] = useState(false);
  const [dismissedArtistIds, setDismissedArtistIds] = useState([]);

  const ageRestrictionVenueOwnershipId = selectedRooms[0]?.venueOwnershipId;
  const { options: ageRestrictionOptions, defaultValue: ageRestrictionDefault } =
    useVenueAgeRestrictionOptions(team?.id, ageRestrictionVenueOwnershipId);

  useEffect(() => {
    // Only auto-default on create flows. Duplication leaves IDs unset, so it counts as create.
    if (holdGroup.id || confirm.id) return;
    if (!ageRestrictionDefault) return;
    if (calendarEventType === "HoldGroup") {
      if (!holdGroup.age_restriction) {
        holdGroupChanged({ ...holdGroup, age_restriction: ageRestrictionDefault });
      }
    } else if (!confirm.age_restriction) {
      confirmChanged({ ...confirm, age_restriction: ageRestrictionDefault });
    }
    // Deps intentionally narrow: fire only when the venue default changes, not on every form edit.
  }, [ageRestrictionDefault, calendarEventType]);

  const debouncedUpdateTicketForecast = useCallback(
    _.debounce((value) => {
      calendarEventTicketForecastChanged(parseInt(value));
    }, 300),
    [calendarEventTicketForecastChanged]
  );

  const debouncedUpdateNoteEditorState = useCallback(
    _.debounce((editorState) => {
      updateCalendarEventNoteEditorState(editorState);
    }, 300),
    [updateCalendarEventNoteEditorState]
  );

  const debouncedFetchContacts = useCallback(
    _.debounce((inputValue, callback) => {
      axios.get(`/teams/${team.id}/contacts/autocomplete`, {
        params: { name: inputValue, omit_ids: contacts.map(c => c.value) }
      }).then(({ data }) => {
        callback(data.map(c => ({ label: c.name, value: c.id, title_email_preview: c.title_email_preview })));
      });
    }, 250),
    [team.id, contacts]
  );

  const debouncedAutoDetection = useCallback(
    _.debounce(async (title, artistIds, venueId, triggerSource) => {
      if (!title && (!artistIds || artistIds.length === 0)) {
        setDetectionResult(null);
        return;
      }

      if (!team.package?.ai_features) {
        setDetectionResult(null);
        return;
      }

      try {
        setDetectionLoading(true);

        const currentGenre = canonicalTags.find(tag => tag.category === 'genre' && selectedGenreTags.includes(tag.id));
        const currentEventType = canonicalTags.find(tag => tag.category === 'event_type' && selectedEventTypeTags.includes(tag.id));

        const response = await axios.post(`/teams/${team.id}/canonical_tags/auto_detect`, {
          title: title || '',
          artist_ids: artistIds || [],
          venue_id: venueId || null,
          current_state: {
            genre: currentGenre ? { id: currentGenre.id, name: currentGenre.name } : null,
            event_type: currentEventType ? { id: currentEventType.id, name: currentEventType.name } : null,
            user_manually_changed_event_type: userManuallyChangedEventType,
            trigger_source: triggerSource
          }
        });

        if (response.data.success) {
          const detection = response.data.detection;
          setDetectionResult(detection);

          if (detection.confidence >= 0.7) {
            if (detection.genre && detection.genre.id && selectedGenreTags.length === 0) {
              setSelectedGenreTags([detection.genre.id]);
            }
            if (detection.event_type && detection.event_type.id &&
              (selectedEventTypeTags.length === 0 || !userManuallyChangedEventType) &&
              triggerSource !== 'artist_change') {
              setSelectedEventTypeTags([detection.event_type.id]);
            }
            // Don't auto-populate artists anymore - we'll show suggestions instead
          }
        } else {
          setDetectionResult(null);
        }
      } catch (error) {
        console.error('Auto-detection error:', error);
        setDetectionResult(null);
      } finally {
        setDetectionLoading(false);
      }
    }, 500),
    [team.id]
  );

  const canEnableDate = (date) => {
    const dateString = date.toDateString();

    var datesToEnable = holdGroup.hold_group_entries.map(entry => {
      return entry.hold.start_time.toDateString();
    });

    if (typeof confirm.start_time !== 'undefined') {
      datesToEnable.push(confirm.start_time)
    }

    return datesToEnable.includes(dateString);
  }

  const calendarMonthChanged = (_selectedDates, _dateStr, instance) => {
    const firstOfMonth = new Date(
      instance.currentYear,
      instance.currentMonth,
      1,
    ).setHours(12);

    setStartTimeValue(firstOfMonth);
    calendarRef.getApi().gotoDate(firstOfMonth);
  }

  useEffect(() => {
    setStartTimeValue(confirm.start_time);
    applyTimeDefaults(
      confirm,
      doorsTimeDefault,
      eventEndTimeDefault,
      eventTimeDefaults,
      !userChangedDoorsTime,
      !userChangedEventEndTime,
      updatedConfirm => confirmChanged(updatedConfirm)
    );
  }, [confirm.start_time])

  const singleCalendarDate = () => {
    const entries = ((holdGroup && holdGroup.hold_group_entries) || []).filter((entry) => !entry._destroy);
    return entries.length === 1 ? new Date(entries[0].hold.start_time) : null;
  };

  const seedConfirmStartFromCalendarDate = () => {
    const calendarDate = singleCalendarDate();
    if (!confirm.start_time && calendarDate) {
      confirmChanged({ ...confirm, start_time: applyDefaultStart(eventTimeDefaults, calendarDate) });
    }
  };

  useEffect(() => {
    if (holdGroup && holdGroup.hold_group_entries && holdGroup.hold_group_entries.length === 1) {
      const holdStartTime = holdGroup.hold_group_entries[0].hold.start_time;
      setStartTimeValue(holdStartTime.setHours(12));
    } else {
      setStartTimeValue(null);
    }

    if (calendarEventType === "Confirm" && !holdGroup?.id) {
      seedConfirmStartFromCalendarDate();
    }
  }, [holdGroup])

  useEffect(() => {
    userChangedDoorsTimeChanged(false);
    userChangedEventEndTimeChanged(false);

    if (confirm && confirm.id) {
      confirmChanged({
        ...confirm,
        start_time: offsetDateForBrowser(confirm.start_time),
        end_time: offsetDateForBrowser(confirm.end_time)
      });
    }
  }, [])

  useEffect(() => {
    if (team && team.id) {
      fetchCanonicalTags(team).then(tags => {
        setCanonicalTags(tags);

        if (confirm && confirm.canonical_tags) {
          const genreTags = confirm.canonical_tags.filter(tag => tag.category === 'genre');
          const eventTypeTags = confirm.canonical_tags.filter(tag => tag.category === 'event_type');
          setSelectedGenreTags(genreTags.map(tag => tag.id));
          setSelectedEventTypeTags(eventTypeTags.map(tag => tag.id));
        } else if (holdGroup && holdGroup.canonical_tags) {
          const genreTags = holdGroup.canonical_tags.filter(tag => tag.category === 'genre');
          const eventTypeTags = holdGroup.canonical_tags.filter(tag => tag.category === 'event_type');
          setSelectedGenreTags(genreTags.map(tag => tag.id));
          setSelectedEventTypeTags(eventTypeTags.map(tag => tag.id));
        } else {
          const concertTag = tags.find(tag => tag.category === 'event_type' && tag.name === 'Concert');
          if (concertTag) {
            setSelectedEventTypeTags([concertTag.id]);
          }
        }
      });
    }
  }, [team])

  useEffect(() => {
    if (calendarEventArtists && calendarEventArtists.length > 0) {
      const artistIds = calendarEventArtists.map(artist => artist.value);
      debouncedAutoDetection(calendarEventTitle, artistIds, venueSelected?.id, 'artist_change');
    }
  }, [calendarEventArtists]);

  useEffect(() => {
    if (calendarEventTitle && calendarEventTitle.trim().length > 0) {
      const artistIds = calendarEventArtists ? calendarEventArtists.map(artist => artist.value) : [];
      debouncedAutoDetection(calendarEventTitle, artistIds, venueSelected?.id, 'title_change');
    }
  }, [calendarEventTitle]);

  useEffect(() => {
    if (venueSelected && (calendarEventTitle || (calendarEventArtists && calendarEventArtists.length > 0))) {
      const artistIds = calendarEventArtists ? calendarEventArtists.map(artist => artist.value) : [];
      debouncedAutoDetection(calendarEventTitle, artistIds, venueSelected.id, 'venue_change');
    }
  }, [venueSelected]);

  return (
    <div className="event-form-container">
      <ToastContainer icon={false} />

      {showNewBuyerModal && (
        <CreateEntityModal
          title="Add New Buyer"
          subtitle="Enter the name of the new buyer company."
          placeholder="Buyer name"
          buttonLabel="Add Buyer"
          initialValue={newBuyerName}
          onClose={() => { setShowNewBuyerModal(false); setNewBuyerName(''); }}
          onSubmit={(name, onError) => {
            createBuyer(team, name,
              (newBuyer) => {
                var newOption = { label: newBuyer.name, value: newBuyer.id };
                buyersChanged([...buyers, newOption]);
                selectedBuyerChanged(newOption);
                setShowNewBuyerModal(false);
                setNewBuyerName('');
                toast.success(`Company "${newBuyer.name}" was created`, { position: toast.POSITION.TOP_CENTER, draggable: false, closeOnClick: false, autoClose: 5000, hideProgressBar: true });
              },
              () => {
                onError();
                toast.error(`Could not create company "${name}"`, { position: toast.POSITION.TOP_CENTER, draggable: false, closeOnClick: false, autoClose: 5000, hideProgressBar: true });
              });
          }}
        />
      )}

      <Popup
        open={buyerToDelete !== null}
        contentStyle={{ border: 'none', borderRadius: '8px', padding: '0px', width: '360px', maxWidth: 'calc(100vw - 16px)' }}
        overlayStyle={{ zIndex: 10000 }}
        closeOnDocumentClick={false}
        className={"popup-modal"}
        onClose={() => setBuyerToDelete(null)}
      >
        <div className="popup-modal-container">
          <div className="border-bottom p-4 d-flex align-items-center justify-content-between"
            style={{ "borderColor": "var(--sl-border-primary)" }}>
            <h5 className="m-0">
              <strong>Delete Buyer</strong>
            </h5>
            <a href="#"
              className="mr-1"
              style={{ "color": "var(--sl-text-quaternary)", "fontSize": "20px" }}
              onClick={(e) => {
                e.preventDefault();
                setBuyerToDelete(null);
              }}>
              <i className="far fa-times"></i>
            </a>
          </div>
          <div className="p-4">
            <p className="mb-0">
              Are you sure you want to delete <strong>{buyerToDelete?.label}</strong>? It will be removed from every event it is set on. This action cannot be undone.
            </p>
          </div>
          <div className="border-top p-3 d-flex justify-content-end" style={{ gap: '8px' }}>
            <a href="#"
              className="btn btn-setlist-secondary"
              onClick={(e) => {
                e.preventDefault();
                setBuyerToDelete(null);
              }}>
              Cancel
            </a>
            <a href="#"
              className="btn btn-setlist-primary"
              style={{ backgroundColor: 'var(--sl-bg-error-solid)', borderColor: 'var(--sl-bg-error-solid)' }}
              onClick={(e) => {
                e.preventDefault();
                const { value, label } = buyerToDelete;
                deleteBuyer(team, value,
                  () => {
                    buyersChanged(buyers.filter((buyer) => buyer.value !== value));
                    if (selectedBuyer?.value === value) {
                      selectedBuyerChanged({});
                    }
                    setBuyerToDelete(null);
                    toast.success(`Buyer "${label}" was deleted`, { position: toast.POSITION.TOP_CENTER, draggable: false, closeOnClick: false, autoClose: 5000, hideProgressBar: true });
                  },
                  () => {
                    toast.error(`Could not delete buyer "${label}"`, { position: toast.POSITION.TOP_CENTER, draggable: false, closeOnClick: false, autoClose: 5000, hideProgressBar: true });
                  });
              }}>
              Delete
            </a>
          </div>
        </div>
      </Popup>

      {showNewPromoterModal && (
        <CreateEntityModal
          title="Add New Promoter"
          subtitle="Enter the name of the new promoter."
          placeholder="Promoter name"
          buttonLabel="Add Promoter"
          initialValue={newPromoterName}
          onClose={() => { setShowNewPromoterModal(false); setNewPromoterName(''); }}
          onSubmit={(name, onError) => {
            createPromoter(team, name,
              (newPromoter) => {
                var newOption = { label: newPromoter.name, value: newPromoter.id };
                promotersChanged([...promoters, newOption]);
                selectedPromoterChanged(newOption);
                setShowNewPromoterModal(false);
                setNewPromoterName('');
                toast.success(`Promoter "${newPromoter.name}" was created`, { position: toast.POSITION.TOP_CENTER, draggable: false, closeOnClick: false, autoClose: 5000, hideProgressBar: true });
              },
              (error) => {
                onError();
                toast.error(`Could not create promoter "${name}"`, { position: toast.POSITION.TOP_CENTER, draggable: false, closeOnClick: false, autoClose: 5000, hideProgressBar: true });
              });
          }}
        />
      )}

      <div className="row py-2">
        <div className="col-12">
          <div className="container-fluid">
            <div className="row">
              <div className="col-11 drag-handle" style={{
                cursor: draggableHeader ? "move" : "default",
                userSelect: draggableHeader ? "none" : "text"
              }}>
                <h5><strong>{formTitle}</strong></h5>
              </div>
              <div className="col-1 text-right">
                <a href="#"
                  className="text-muted"
                  style={{ cursor: 'pointer' }}
                  onClick={
                    (e) => {
                      e.preventDefault();
                      calendarEventFormClosed(onClose);
                    }
                  } >
                  <i className="fa fa-times"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12">
          <hr />
        </div>
        <div className="col-12">
          <div className="container-fluid">
            <div className="row">
              <div className="col">
                <form onSubmit={
                  (e) => {
                    e.preventDefault();

                    if(canSubmitForm(calendarEventType, calendarEventTitle, selectedRooms, holdGroup, confirm, submittingForm, makeUnavailable, forDuplication)){
                      var holdGroupCopy = {...holdGroup};

                      if (makeUnavailable && holdGroupCopy && holdGroupCopy.hold_group_entries) {
                        var filteredHoldGroupEntries = holdGroupCopy.hold_group_entries.filter((holdGroupEntry) => {
                          var firstHoldAvailability = (holdGroupEntry.hold.hold_availability || [])[0];
                          return firstHoldAvailability && !firstHoldAvailability.is_confirm;
                        });

                        holdGroupCopy = { ...holdGroupCopy, hold_group_entries: filteredHoldGroupEntries };
                      }

                      const canonicalTagIds = [...selectedEventTypeTags, ...selectedGenreTags];
                      submitEventForm(csrfToken, team, () => {calendarEventFormClosed(onClose)}, calendarEventType, calendarEventArtists, calendarEventTitle, venueSelected, calendarEventTicketForecast, calendarEventNoteEditorState, confirm, holdGroupCopy, onSuccess, selectedPromoter, selectedBuyer, canonicalTagIds, selectedRooms, contacts);
                    }
                  }
                }>
                  {!forDuplication && currentUser.can_create_calendar_event ? (
                    <div className="form-group">
                      <div className="sl-tabs-border sl-tabs-border-block" role="tablist" aria-label="Event Type">
                        <button type="button"
                          role="tab"
                          aria-selected={calendarEventType === "HoldGroup"}
                          onClick={
                            (e) => {
                              e.preventDefault();
                              updateCalendarEventType("HoldGroup");
                            }
                          }
                          className={"sl-tab-border" + (calendarEventType === "HoldGroup" ? " active" : "")}>
                          Hold
                        </button>
                        <button type="button"
                          role="tab"
                          aria-selected={calendarEventType === "Confirm"}
                          onClick={
                            (e) => {
                              e.preventDefault();
                              updateCalendarEventType("Confirm");

                              if (holdGroup && holdGroup.hold_position_context && holdGroup.hold_position_context.start_time) {
                                var defaultDate = offsetDateForBrowser(holdGroup.hold_position_context.start_time);
                                confirmChanged({ ...confirm, start_time: applyDefaultStart(eventTimeDefaults, defaultDate) });
                              } else if (!holdGroup?.id) {
                                seedConfirmStartFromCalendarDate();
                              }
                            }
                          }
                          className={"sl-tab-border" + (calendarEventType === "Confirm" ? " active" : "")}>
                          Confirm
                        </button>
                      </div>
                    </div>
                  ) : null}
                  {!forDuplication ? (
                    <div className="form-group">
                      <label htmlFor="new-event-template" className="text-muted">
                        Template
                        <span className="text-optional pl-2">
                          (optional)
                        </span>
                      </label>
                      <EventTemplateSelect
                        teamId={team.id}
                        id="new-event-template"
                        value={confirm.event_template || null}
                        onChange={(option) => {
                          confirmChanged({ ...confirm, event_template: option })
                          holdGroupChanged({ ...holdGroup, event_template: option })
                        }}
                      />
                    </div>
                  ) : null}
                  <div className="form-group">
                    <label htmlFor="new-event-title" className="text-muted">Event Name</label>
                    <DebounceInput type="text"
                      className="form-control"
                      value={calendarEventTitle || ""}
                      onChange={(e) => updateCalendarEventTitle(e.target.value)}
                      id="new-event-title" />
                  </div>
                  {forDuplication && confirm.copyable_offers?.length > 0 && (
                  <div className="form-group">
                    <CopyOffersPicker
                      offers={confirm.copyable_offers}
                      selectedIds={confirm.copy_offer_ids || []}
                      onChange={(ids) => confirmChanged({ ...confirm, copy_offer_ids: ids })}
                    />
                  </div>
                  )}
                  {!forDuplication && (
                  <div className="form-group">
                    <label htmlFor="new-event-artists" className="text-muted">
                      Artist(s)
                      <span className="text-optional pl-2">
                        (optional)
                      </span>
                    </label>
                    <ArtistChipsField
                      id="new-event-artists"
                      value={calendarEventArtists}
                      teamId={team.id}
                      onChange={(options) => {
                        if (calendarEventArtists && calendarEventArtists.length > 0) {
                          const newOptions = options || [];
                          const removedArtists = calendarEventArtists.filter(
                            oldArtist => !newOptions.some(newArtist => newArtist.value === oldArtist.value)
                          );
                          if (removedArtists.length > 0) {
                            const removedIds = removedArtists.map(a => a.value || a.id);
                            setDismissedArtistIds([...new Set([...dismissedArtistIds, ...removedIds])]);
                          }
                        }
                        updateCalendarEventArtists(options || [], userChangedCalendarEventTitle);
                      }} />
                  </div>
                  )}
                  {!forDuplication && detectionResult && detectionResult.artist_suggestions && (() => {
                    const selectedArtistIds = (calendarEventArtists || []).map(a => a.value || a.id);
                    const filteredExisting = detectionResult.artist_suggestions.existing_artists?.filter(
                      artist => !selectedArtistIds.includes(artist.id) && !dismissedArtistIds.includes(artist.id)
                    ) || [];
                    const hasAnySuggestions = filteredExisting.length > 0;

                    if (!hasAnySuggestions) return null;

                    return (
                      <div style={{
                        backgroundColor: 'var(--od-c-f8f9fa, #f8f9fa)',
                        border: '1px solid var(--od-c-dee2e6, #dee2e6)',
                        borderRadius: '4px',
                        padding: '8px 12px',
                        marginBottom: '15px',
                        fontSize: '14px'
                      }}>
                        <div className="text-muted small mb-2">
                          <i className="fas fa-sparkles mr-1"></i>
                          Suggested artists detected:
                        </div>
                        <div>
                          {filteredExisting.map((artist) => (
                            <div key={`existing-${artist.id}`} className="d-inline-flex align-items-center mr-2 mb-2">
                              <div style={{
                                backgroundColor: 'var(--od-c-ffffff, #fff)',
                                border: '1px solid var(--od-c-ced4da, #ced4da)',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                overflow: 'hidden'
                              }}>
                                <span style={{
                                  padding: '5px 10px',
                                  fontSize: '13px',
                                  display: 'inline-block'
                                }}>
                                  {artist.name}
                                </span>
                                <div style={{
                                  display: 'flex',
                                  borderLeft: '1px solid var(--od-c-ced4da, #ced4da)',
                                  backgroundColor: 'var(--od-c-f8f9fa, #f8f9fa)'
                                }}>
                                  <button
                                    type="button"
                                    className="btn btn-sm"
                                    style={{
                                      background: 'transparent',
                                      border: 'none',
                                      borderRadius: 0,
                                      color: 'var(--od-c-495057, #495057)',
                                      padding: '5px 10px',
                                      fontSize: '12px',
                                      minWidth: '32px'
                                    }}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--od-c-e9ecef, #e9ecef)'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                    onClick={() => {
                                      const newArtist = { value: artist.id, label: artist.name, id: artist.id, name: artist.name };
                                      const updatedArtists = [...(calendarEventArtists || []), newArtist];
                                      updateCalendarEventArtists(updatedArtists, userChangedCalendarEventTitle);

                                      const filtered = { ...detectionResult };
                                      filtered.artist_suggestions.existing_artists = filtered.artist_suggestions.existing_artists.filter(a => a.id !== artist.id);
                                      if (filtered.artist_suggestions.existing_artists.length === 0) {
                                        delete filtered.artist_suggestions.existing_artists;
                                      }
                                      if (!filtered.artist_suggestions.existing_artists && !filtered.artist_suggestions.suggested_artists) {
                                        delete filtered.artist_suggestions;
                                      }
                                      setDetectionResult(filtered);
                                    }}
                                  >
                                    <i className="fas fa-check"></i>
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-sm"
                                    style={{
                                      background: 'transparent',
                                      border: 'none',
                                      borderRadius: 0,
                                      borderLeft: '1px solid var(--od-c-ced4da, #ced4da)',
                                      color: 'var(--od-c-495057, #495057)',
                                      padding: '5px 10px',
                                      fontSize: '12px',
                                      minWidth: '32px'
                                    }}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--od-c-e9ecef, #e9ecef)'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                    onClick={() => {
                                      setDismissedArtistIds([...dismissedArtistIds, artist.id]);

                                      const filtered = { ...detectionResult };
                                      filtered.artist_suggestions.existing_artists = filtered.artist_suggestions.existing_artists.filter(a => a.id !== artist.id);
                                      if (filtered.artist_suggestions.existing_artists.length === 0) {
                                        delete filtered.artist_suggestions.existing_artists;
                                      }
                                      if (!filtered.artist_suggestions.existing_artists && !filtered.artist_suggestions.suggested_artists) {
                                        delete filtered.artist_suggestions;
                                      }
                                      setDetectionResult(filtered);
                                    }}
                                  >
                                    <i className="fas fa-times"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })()}
                  <div className="form-group">
                    <label htmlFor="new-event-rooms" className="text-muted">Venue</label>
                    <RoomSelector
                      rooms={rooms}
                      venueOwnerships={venueOwnerships}
                      selectedRooms={selectedRooms}
                      id="new-event-rooms"
                      onAddVenue={canManageVenues ? () => setShowVenueModal(true) : null}
                      menuPortalTarget={!forDuplication ? document.querySelector('body') : null}
                      onChange={(selected) => {
                        setSelectedRooms(selected || []);
                        
                        // Update the venue selection for backward compatibility
                        if (selected && selected.length > 0) {
                          const firstRoom = selected[0];
                          const venueOwnership = venueOwnerships.find(vo => vo.id === firstRoom.venueOwnershipId);
                          if (venueOwnership && venueOwnership.venueable_type === "Venue") {
                            const venue = venuesOptions.find(v => v.id === venueOwnership.venueable_id);
                            if (venue) {
                              updateSelectedVenue(venuesOptions, { value: venue.id, label: venue.name });
                              if(typeof(onVenueChange) === "function"){
                                onVenueChange({ value: venue.id, label: venue.name });
                              }
                            }
                          }
                        } else {
                          updateSelectedVenue(venuesOptions, null);
                          if(typeof(onVenueChange) === "function"){
                            onVenueChange(null);
                          }
                        }
                      }}
                    />
                  </div>
                  {canManageVenues && (
                    <VenueFormModal
                      isOpen={showVenueModal}
                      onClose={() => setShowVenueModal(false)}
                      csrfToken={csrfToken}
                      team={team}
                      venueStateOptions={venueStateOptions}
                      availableTimezones={availableTimezones}
                      onVenueAdded={(ownership) => {
                        const next = buildCreatedVenueSelection(ownership, rooms, venueOwnerships);
                        if (typeof roomsChanged === 'function') roomsChanged(next.rooms);
                        if (typeof venueOwnershipsChanged === 'function') venueOwnershipsChanged(next.venueOwnerships);
                        setSelectedRooms(next.selectedRooms);
                        if (typeof updateSelectedVenue === 'function') {
                          updateSelectedVenue([...(venuesOptions || []), next.selectedVenue], next.selectedVenue);
                        }
                        if (typeof onVenueChange === 'function') {
                          onVenueChange(next.selectedVenue);
                        }
                        setShowVenueModal(false);
                      }}
                    />
                  )}
                  {currentUser.role.name !== "Promoter" ? (
                    <div className="form-group">
                      <label htmlFor="new-event-promoter"
                        className="text-muted">
                        Promoter
                      </label>
                      <AsyncSelect
                        placeholder={"Select a promoter"}
                        styles={selectStyles}
                        menuPortalTarget={!forDuplication ? document.querySelector('body') : null}
                        isClearable={true}
                        defaultOptions={promoters}
                        id="edit-event-promoter"
                        value={promoters.find(promoter => promoter.value === selectedPromoter?.value)}
                        loadOptions={(inputValue, callback) => debouncedFetchPromoters(team, inputValue, callback)}
                        components={{
                          MenuList: (props) => (
                            <div>
                              <components.MenuList {...props}>{props.children}</components.MenuList>
                              <div
                                style={{ borderTop: '1px solid var(--od-c-e9eaeb, #e9eaeb)', padding: '10px 12px', cursor: 'pointer' }}
                                onMouseDown={(e) => {
                                  e.preventDefault();
                                  setNewPromoterName(props.selectProps.inputValue || '');
                                  setShowNewPromoterModal(true);
                                }}
                              >
                                <span style={{ color: '#1982C4', fontWeight: 600, fontSize: 14 }}>
                                  <i className="fas fa-plus" style={{ marginRight: 8 }}></i>
                                  Add New Promoter
                                </span>
                              </div>
                            </div>
                          )
                        }}
                        onChange={(option) => {
                          if (option === null) {
                            selectedPromoterChanged({});
                          } else {
                            selectedPromoterChanged(option);
                          }
                        }}
                      />
                    </div>
                  ) : null}
                  <div className="form-group">
                    <label htmlFor="new-event-buyer"
                      className="text-muted">
                      Buyer
                    </label>
                    <AsyncSelect placeholder={"Select a buyer"}
                      styles={selectStyles}
                      menuPortalTarget={!forDuplication ? document.querySelector('body') : null}
                      isClearable={true}
                      defaultOptions={buyers.map((buyer) => { return { label: buyer.label, value: buyer.value } })}
                      id="new-event-buyer"
                      value={_.isEmpty(selectedBuyer) ? null : selectedBuyer}
                      loadOptions={(inputValue, callback) => debouncedFetchBuyers(team, inputValue, callback)}
                      components={{
                        Option: (props) => <BuyerOption {...props} onDelete={setBuyerToDelete} />,
                        MenuList: (props) => (
                          <div>
                            <components.MenuList {...props}>{props.children}</components.MenuList>
                            <div
                              style={{ borderTop: '1px solid var(--od-c-e9eaeb, #e9eaeb)', padding: '10px 12px', cursor: 'pointer' }}
                              onMouseDown={(e) => {
                                e.preventDefault();
                                setNewBuyerName(props.selectProps.inputValue || '');
                                setShowNewBuyerModal(true);
                              }}
                            >
                              <span style={{ color: '#1982C4', fontWeight: 600, fontSize: 14 }}>
                                <i className="fas fa-plus" style={{ marginRight: 8 }}></i>
                                Add New Buyer
                              </span>
                            </div>
                          </div>
                        )
                      }}
                      onChange={(option) => {
                        if (option === null) {
                          selectedBuyerChanged({});
                        } else {
                          selectedBuyerChanged(option);
                        }
                      }} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="new-event-type"
                      className="text-muted">
                      Event Type
                      <span className="text-optional pl-2">
                        (optional)
                      </span>
                      {detectionLoading && (
                        <span className="pl-2">
                          <i className="fa fa-spinner fa-spin text-muted"></i>
                        </span>
                      )}
                    </label>
                    <Select
                      id="new-event-type"
                      styles={selectStyles}
                      menuPortalTarget={!forDuplication ? document.querySelector('body') : null}
                      isClearable={true}
                      options={canonicalTags
                        .filter(tag => tag.category === 'event_type')
                        .map(tag => ({ value: tag.id, label: tag.name }))}
                      value={canonicalTags
                        .filter(tag => tag.category === 'event_type' && selectedEventTypeTags.includes(tag.id))
                        .map(tag => ({ value: tag.id, label: tag.name }))[0] || null}
                      onChange={(option) => {
                        setUserManuallyChangedEventType(true);
                        if (option) {
                          setSelectedEventTypeTags([option.value]);
                        } else {
                          setSelectedEventTypeTags([]);
                        }
                      }}
                    />
                  </div>
                  <div className="form-group" style={{ display: "flex", alignItems: "center", gap: 5 }}>
                    <input type="checkbox"
                      id="is-rental"
                      checked={(calendarEventType === "Confirm" ? confirm.is_rental : holdGroup.is_rental) || false}
                      onChange={(e) => {
                        if (calendarEventType === "Confirm") {
                          confirmChanged({ ...confirm, is_rental: e.target.checked });
                        } else {
                          holdGroupChanged({ ...holdGroup, is_rental: e.target.checked });
                        }
                      }} />
                    <label htmlFor="is-rental"
                      style={{marginBottom: 0}}
                      className="text-muted">
                      This is a room rental
                    </label>
                  </div>
                  <div className="form-group">
                    <label htmlFor="new-event-genre"
                      className="text-muted">
                      Genre
                      <span className="text-optional pl-2">
                        (optional)
                      </span>
                    </label>
                    <Select
                      id="new-event-genre"
                      styles={selectStyles}
                      menuPortalTarget={!forDuplication ? document.querySelector('body') : null}
                      isClearable={true}
                      options={canonicalTags
                        .filter(tag => tag.category === 'genre')
                        .map(tag => ({ value: tag.id, label: tag.name }))}
                      value={canonicalTags
                        .filter(tag => tag.category === 'genre' && selectedGenreTags.includes(tag.id))
                        .map(tag => ({ value: tag.id, label: tag.name }))[0] || null}
                      onChange={(option) => {
                        if (option) {
                          setSelectedGenreTags([option.value]);
                        } else {
                          setSelectedGenreTags([]);
                        }
                      }}
                    />
                  </div>
                  {calendarEventType === "HoldGroup" ? (
                    <HoldPositionPicker csrfToken={csrfToken}
                      team={team}
                      venueSelected={venueSelected}
                      holdGroup={holdGroup}
                      holdGroupCalendarDateClicked={holdGroupCalendarDateClicked}
                      holdGroupDates={holdGroupDates}
                      makeUnavailable={makeUnavailable}
                      setMakeUnavailable={setMakeUnavailable}
                      holdGroupHoldPositionUpdated={holdGroupHoldPositionUpdated}
                      holdPositionTargetToggled={holdPositionTargetToggled}
                      holdGroupHoldRemoved={holdGroupHoldRemoved}
                      fetchHoldAvailability={fetchHoldAvailability}
                      selectedRooms={selectedRooms}
                      calendarRef={calendarRef}
                      calendarStartDate={calendarStartDate} />
                  ) : null}
                  {calendarEventType === "Confirm" ? (
                    <React.Fragment>
                      <div className="form-group">
                        <label htmlFor="start_date_and_time" className="text-muted">
                          Event Start Date/Time
                        </label>
                        <div className="flatpickr-date-input px-2 d-flex align-items-center">
                          <div className="pr-2" style={{ "fontSize": "18px" }}>
                            <i className="far fa-calendar"></i>
                          </div>
                          {!forDuplication && holdGroup.id ? (
                            <Flatpickr
                              {...dateTimePickerProps({
                                value: confirm.start_time,
                                unavailableMessage: "Pick one of this hold's dates.",
                                options: { enable: [canEnableDate], disableMobile: true, ...emptyStartClock },
                                defaultTime: confirm.start_time ? undefined : (date) => applyDefaultStart(eventTimeDefaults, date),
                                onDates: (dates, dateText, instance, entry) => {
                                  const picked = (!confirm.start_time && dates[0] && entry?.typed && !entry.hasTime) ? applyDefaultStart(eventTimeDefaults, dates[0]) : dates[0];
                                  confirmChanged({ ...confirm, start_time: picked });
                                }
                              })}
                              placeholder={"Select date"}
                              value={confirm.start_time}
                            />
                          ) : (
                            <Flatpickr
                              key={`start-picker-${confirm.end_time ? confirm.end_time.getTime() : 'empty'}`}
                              {...dateTimePickerProps({
                                value: confirm.start_time || startTimeValue,
                                minDate: pickerFloor,
                                unavailableMessage: "The start can't be after the end time.",
                                options: {
                                  disableMobile: true,
                                  ...emptyStartClock,
                                  maxDate: (forDuplication || !userChangedEventEndTime)
                                    ? null
                                    : ((confirm.end_time && confirm.end_time > new Date()) ? confirm.end_time : null),
                                  onDayCreate: (dObj, dStr, fp, dayElem) => {
                                    fp = {
                                      ...fp,
                                      isEventStart: true,
                                      eventStart: confirm.start_time,
                                      eventEnd: userChangedEventEndTime ? confirm.end_time : undefined
                                    }
                                    onDayCreate(dObj, dStr, fp, dayElem);
                                  }
                                },
                                defaultTime: confirm.start_time ? undefined : (date) => applyDefaultStart(eventTimeDefaults, date),
                                onDates: (dates, dateText, instance, entry) => {
                                  const picked = (!confirm.start_time && dates[0] && entry?.typed && !entry.hasTime) ? applyDefaultStart(eventTimeDefaults, dates[0]) : dates[0];
                                  confirmChanged({ ...confirm, start_time: picked });
                                }
                              })}
                              placeholder={"Select date"}
                              value={confirm.start_time || startTimeValue}
                              onOpen={(dates, dateText, instance) => {
                                refreshPickerFloor(dates, dateText, instance);
                                if (!startTimeValue && calendarStartDate) {
                                  setStartTimeValue(calendarStartDate.setHours(12));
                                }
                              }}
                              onMonthChange={calendarMonthChanged}
                              onYearChange={calendarMonthChanged}
                            />
                          )}
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="doors_date_and_time" className="text-muted">
                          Doors Date/Time
                        </label>
                        <div className="flatpickr-date-input px-2 d-flex align-items-center">
                          <div className="pr-2" style={{ "fontSize": "18px" }}>
                            <i className="far fa-calendar"></i>
                          </div>
                          {!forDuplication && holdGroup.id ? (
                            <Flatpickr
                              {...dateTimePickerProps({
                                value: confirm.door_time,
                                unavailableMessage: "Pick one of this hold's dates.",
                                options: { enable: [canEnableDate], disableMobile: true },
                                onDates: dates => {
                                  userChangedDoorsTimeChanged(true);
                                  confirmChanged({ ...confirm, door_time: dates[0] });
                                }
                              })}
                              placeholder={"Select date"}
                              value={confirm.door_time}
                            />
                          ) : (
                            <Flatpickr
                              {...dateTimePickerProps({
                                value: confirm.door_time,
                                minDate: pickerFloor,
                                options: { disableMobile: true },
                                onDates: dates => {
                                  userChangedDoorsTimeChanged(true);
                                  confirmChanged({ ...confirm, door_time: dates[0] });
                                }
                              })}
                              placeholder={"Select date"}
                              value={confirm.door_time}
                              onOpen={refreshPickerFloor}
                            />
                          )}
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="end_date_and_time" className="text-muted">
                          Event End Date/Time
                        </label>
                        <div className="flatpickr-date-input px-2 d-flex align-items-center">
                          <div className="pr-2" style={{ "fontSize": "18px" }}>
                            <i className="far fa-calendar"></i>
                          </div>
                          {!forDuplication && holdGroup.id ? (
                            <Flatpickr
                              {...dateTimePickerProps({
                                value: confirm.end_time,
                                unavailableMessage: "Pick one of this hold's dates.",
                                options: { enable: [canEnableDate], disableMobile: true },
                                onDates: dates => {
                                  userChangedEventEndTimeChanged(true);
                                  confirmChanged({ ...confirm, end_time: dates[0] });
                                }
                              })}
                              placeholder={"Select date"}
                              value={confirm.end_time}
                            />
                          ) : (
                            <Flatpickr
                              {...dateTimePickerProps({
                                value: confirm.end_time,
                                minDate: (confirm.start_time || pickerFloor),
                                minDateMessage: confirm.start_time ? "The end time can't be before the start time." : undefined,
                                options: {
                                  disableMobile: true,
                                  onDayCreate: (dObj, dStr, fp, dayElem) => {
                                    fp = {
                                      ...fp,
                                      isEventEnd: true,
                                      eventStart: confirm.start_time,
                                      eventEnd: confirm.end_time
                                    }
                                    onDayCreate(dObj, dStr, fp, dayElem);
                                  }
                                },
                                onDates: dates => {
                                  userChangedEventEndTimeChanged(true);
                                  confirmChanged({ ...confirm, end_time: dates[0] });
                                }
                              })}
                              placeholder={"Select date"}
                              value={confirm.end_time}
                              onOpen={confirm.start_time ? undefined : refreshPickerFloor}
                            />
                          )}
                        </div>
                      </div>
                    </React.Fragment>
                  ) : null}
                  <div className="form-group pb-2">
                    <label className="text-muted">
                      Ticket Forecast
                    </label>
                    <MaskedInput className="form-control"
                      style={{ "fontSize": "14px" }}
                      value={calendarEventTicketForecast || ""}
                      onChange={e => {
                        debouncedUpdateTicketForecast(e.target.value);
                      }}
                      mask={createNumberMask({
                        prefix: "",
                        decimalLimit: 0,
                        includeThousandsSeparator: false
                      })} />
                  </div>
                  <div className="form-group pb-2">
                    <label htmlFor="new-event-notes" className="text-muted">
                      Notes
                      <span className="text-optional pl-2">
                        (optional)
                      </span>
                    </label>
                    <RichEditor
                      editorState={localNoteEditorState}
                      onEditorStateChange={(editorState) => {
                        setLocalNoteEditorState(editorState);
                        debouncedUpdateNoteEditorState(editorState);
                      }} />
                  </div>
                  {calendarEventType === "HoldGroup" && (
                    <div className="form-group">
                      <label
                        className="text-muted d-flex align-items-center"
                        style={{ cursor: 'pointer' }}
                        onClick={() => setContactsExpanded(!contactsExpanded)}
                      >
                        Contacts
                        <span className="text-optional pl-2">(optional)</span>
                        <i className={`fa fa-chevron-${contactsExpanded ? 'up' : 'down'} ml-auto`}></i>
                      </label>
                      {contactsExpanded && (
                        <React.Fragment>
                          <AsyncCreatableSelect
                            isMulti
                            cacheOptions
                            styles={selectStyles}
                            loadOptions={debouncedFetchContacts}
                            value={contacts}
                            onChange={(selected) => setContacts(selected || [])}
                            onCreateOption={(inputValue) => {
                              setNewContactForm({ name: inputValue, email: '', phone: '' });
                            }}
                            placeholder="Search contacts..."
                            noOptionsMessage={() => "Type to search contacts"}
                            formatCreateLabel={(inputValue) => `Create "${inputValue}"`}
                            formatOptionLabel={({ label, title_email_preview }) => (
                              <div>
                                <div style={{ fontSize: "12px" }}>{label}</div>
                                {title_email_preview && title_email_preview.length > 0 && (
                                  <div className="text-muted" style={{ fontSize: "10px" }}>{title_email_preview}</div>
                                )}
                              </div>
                            )}
                          />
                          {newContactForm && (
                            <div className="border rounded p-3 mt-2">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <strong style={{ fontSize: "13px" }}>New Contact</strong>
                                <button
                                  type="button"
                                  className="btn btn-link btn-sm p-0 text-muted"
                                  onClick={() => setNewContactForm(null)}
                                >
                                  <i className="fa fa-times"></i>
                                </button>
                              </div>
                              <input
                                type="text"
                                className="form-control form-control-sm mb-2"
                                placeholder="Name"
                                value={newContactForm.name}
                                onChange={(e) => setNewContactForm({ ...newContactForm, name: e.target.value })}
                              />
                              <input
                                type="email"
                                className="form-control form-control-sm mb-2"
                                placeholder="Email (optional)"
                                value={newContactForm.email}
                                onChange={(e) => setNewContactForm({ ...newContactForm, email: e.target.value })}
                              />
                              <MaskedInput
                                mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                className="form-control form-control-sm mb-2"
                                placeholder="Phone (optional)"
                                guide={false}
                                value={newContactForm.phone}
                                onChange={(e) => setNewContactForm({ ...newContactForm, phone: e.target.value })}
                              />
                              <button
                                type="button"
                                className="btn btn-primary btn-sm btn-block"
                                disabled={!newContactForm.name || newContactForm.name.trim().length === 0}
                                onClick={() => {
                                  const newContact = {
                                    label: newContactForm.name,
                                    value: `new_${Date.now()}`,
                                    isNew: true,
                                    contactName: newContactForm.name,
                                    contactEmail: newContactForm.email || undefined,
                                    contactPhone: newContactForm.phone || undefined
                                  };
                                  setContacts([...contacts, newContact]);
                                  setNewContactForm(null);
                                }}
                              >
                                Add Contact
                              </button>
                            </div>
                          )}
                        </React.Fragment>
                      )}
                    </div>
                  )}
                  <div className="form-group">
                    <label
                      className="text-muted d-flex align-items-center"
                      style={{ cursor: 'pointer' }}
                      onClick={() => setAgeRestrictionExpanded(!ageRestrictionExpanded)}
                    >
                      Age Restriction
                      <span className="text-optional pl-2">(optional)</span>
                      <i className={`fa fa-chevron-${ageRestrictionExpanded ? 'up' : 'down'} ml-auto`}></i>
                    </label>
                    {ageRestrictionExpanded && (
                      <Select
                        styles={selectStyles}
                        menuPortalTarget={typeof document !== 'undefined' ? document.querySelector('body') : null}
                        isClearable={true}
                        options={ageRestrictionOptions}
                        value={
                          (calendarEventType === "HoldGroup" ? holdGroup.age_restriction : confirm.age_restriction)
                            ? { value: calendarEventType === "HoldGroup" ? holdGroup.age_restriction : confirm.age_restriction, label: calendarEventType === "HoldGroup" ? holdGroup.age_restriction : confirm.age_restriction }
                            : null
                        }
                        onChange={(option) => {
                          const val = option ? option.value : null;
                          if (calendarEventType === "HoldGroup") {
                            holdGroupChanged({ ...holdGroup, age_restriction: val });
                          } else {
                            confirmChanged({ ...confirm, age_restriction: val });
                          }
                        }}
                      />
                    )}
                  </div>
                  {calendarEventErrors.length > 0 ? (
                    <div className="form-group">
                      <div className="p-3 mb-2 bg-danger text-white rounded">
                        <ul className="mb-0">
                          {calendarEventErrors.map((error, key) =>
                            <li key={key}>{error}</li>
                          )}
                        </ul>
                      </div>
                    </div>
                  ) : null}
                  <div className="row pb-5 mt-5">
                    {!forDuplication && canDeleteConfirmOrHoldGroup(holdGroup, confirm) ? (
                      <div className="col-12 col-md-3 pr-md-1">
                        <Popup
                          trigger={open => (
                            <a href="#"
                              onClick={
                                (e) => {
                                  e.preventDefault();

                                  // WARNING: This no longer works with Confirms
                                  // (window.confirm('Are you sure?')
                                  //   && deleteEvent(csrfToken, team, () => {calendarEventFormClosed(onClose)}, holdGroup, confirm));
                                  holdGroupDeletionChanged({ hold_group_id: holdGroup.id });
                                }
                              }
                              className="btn btn-external btn-block my-1 my-md-0">
                              <i className="fa fa-trash"></i>
                            </a>
                          )}
                          on={["hover"]}
                          contentStyle={tooltipContentStyle}
                          position="top center"
                          closeOnDocumentClick
                        >
                          <span>Delete Event</span>
                        </Popup>
                      </div>
                    ) : null}
                    <div className={!forDuplication && canDeleteConfirmOrHoldGroup(holdGroup, confirm) ? "col-12 col-md-9 pl-md-1" : "col-12"}>
                      <button type="submit"
                              disabled={!canSubmitForm(calendarEventType, calendarEventTitle, selectedRooms, holdGroup, confirm, submittingForm, makeUnavailable, forDuplication)}
                              className="btn btn-primary btn-block">
                        {submittingForm ? (
                          <React.Fragment>
                            <img src="/uploading-loading.gif"
                              className="mr-2"
                              style={{ width: "16px" }} />
                            <strong>{formButtonLabel}</strong>
                          </React.Fragment>
                        ) : (
                          <strong>{formButtonLabel}</strong>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

EventForm.propTypes = {
  formTitle: PropTypes.string.isRequired,
  formButtonLabel: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  venuesOptions: PropTypes.array,
  venueSelected: PropTypes.object,
  rooms: PropTypes.array,
  venueOwnerships: PropTypes.array,
  submitEventForm: PropTypes.func.isRequired,
  updateSelectedVenue: PropTypes.func.isRequired,
  calendarEventFormClosed: PropTypes.func.isRequired,
  deleteEvent: PropTypes.func,
  holdGroup: PropTypes.object,
  confirm: PropTypes.object,
  confirmChanged: PropTypes.func,
  calendarEventTitle: PropTypes.string,
  updateCalendarEventTitle: PropTypes.func.isRequired,
  calendarEventArtists: PropTypes.array,
  updateCalendarEventArtists: PropTypes.func,
  calendarEventType: PropTypes.string,
  updateCalendarEventType: PropTypes.func.isRequired,
  calendarEventTicketForecast: PropTypes.number,
  calendarEventTicketForecastChanged: PropTypes.func.isRequired,
  calendarEventNoteEditorState: PropTypes.object,
  updateCalendarEventNoteEditorState: PropTypes.func.isRequired,
  calendarEventErrors: PropTypes.array,
  userChangedCalendarEventTitle: PropTypes.bool,
  holdGroupCalendarDateClicked: PropTypes.func,
  holdGroupDates: PropTypes.array,
  holdGroupHoldPositionUpdated: PropTypes.func,
  holdPositionTargetToggled: PropTypes.func,
  holdGroupHoldRemoved: PropTypes.func,
  confirmStartDateUpdated: PropTypes.func.isRequired,
  confirmStartTimeUpdated: PropTypes.func.isRequired,
  fetchHoldAvailability: PropTypes.func,
  confirmHoldUpdated: PropTypes.func,
  calendarRef: PropTypes.object,
  calendarStartDate: PropTypes.instanceOf(Date),
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  selectedPromoter: PropTypes.object,
  selectedPromoterChanged: PropTypes.func.isRequired,
  buyers: PropTypes.array,
  buyersChanged: PropTypes.func.isRequired,
  promoters: PropTypes.array,
  promotersChanged: PropTypes.func.isRequired,
  selectedBuyer: PropTypes.object,
  selectedBuyerChanged: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  holdGroupDeletion: PropTypes.object,
  holdGroupDeletionChanged: PropTypes.func,
  holdGroupDeletionReasonChanged: PropTypes.func,
  holdGroupDeletionExplanationChanged: PropTypes.func,
  holdGroupDeletionFollowUpChanged: PropTypes.func,
  holdGroupDeletionFollowUpAtChanged: PropTypes.func,
  deleteHoldGroup: PropTypes.func,
  onVenueChange: PropTypes.func,
  submittingForm: PropTypes.bool,
  doorsTimeDefault: PropTypes.object.isRequired,
  eventEndTimeDefault: PropTypes.object.isRequired,
  eventTimeDefaults: PropTypes.object,
  userChangedDoorsTime: PropTypes.bool,
  userChangedDoorsTimeChanged: PropTypes.func,
  userChangedEventEndTime: PropTypes.bool,
  userChangedEventEndTimeChanged: PropTypes.func,
  applyTimeDefaults: PropTypes.func.isRequired,
  holdGroupChanged: PropTypes.func,
  forDuplication: PropTypes.bool,
  draggableHeader: PropTypes.bool,
  preSelectedRooms: PropTypes.array,
  canManageVenues: PropTypes.bool,
  roomsChanged: PropTypes.func,
  venueOwnershipsChanged: PropTypes.func,
  venueStateOptions: PropTypes.array,
  availableTimezones: PropTypes.array
};

export default EventForm;
